import toast from 'react-hot-toast';

export const useToast = () => toast;